/*
 |------------------------------------------------------------------------------
 | Enhanced ecommerce - Impressions
 |------------------------------------------------------------------------------
 */

import { baseEvent } from '.';
import { push } from '../../01-helpers/utilities/tag-manager';

/* ========================================================================== */

export function pushProductImpressions(ecommerceData) {
    if(!ecommerceData?.impressions?.length) {
        return;
    }

    push({
        ...baseEvent,
        event: 'productImpressions',
        ecommerce: ecommerceData
    });
}

export function pushProductClick(clickedResultElement, ecommerceData) {
    const time = (
        clickedResultElement.dataset.teetime &&
        JSON.parse(clickedResultElement.dataset.teetime)?.time
    );

    if(!time) {
        return;
    }

    const matchingImpression = ecommerceData?.impressions?.find(i => i.name === time);

    if(!matchingImpression) {
        return;
    }

	push({
		...baseEvent,
		event: 'productClick',
		ecommerce: {
			click: {
				actionField: {
					list: matchingImpression.list
				},
				products: [
					matchingImpression
				]
			}
		}
    });
}
